import { NewBookingButton } from '@components/Common/NewBookingButton';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiLink } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';

export const CancelledBookingFeedBack = () => (
  <ContentWrapperCustomerApp>
    <div>
      <p className='mt-20 text-4xl font-bold text-primary'>{t`Thank you for your feedback!`}</p>
      {/* eslint-disable-next-line noddi/no-emoji-in-ui -- deliberate emoji in customer-facing copy: it carries the tone of the message, it is not a status a NoddiIcon could show */}
      <p className='mt-7 text-3xl font-bold text-secondary'>{t`We hope to see you back again soon`} 🚀</p>

      <div className='mt-10 flex w-full items-center gap-4 lg:mt-40'>
        <NoddiLink variant='outline' className='flex-1 self-end lg:flex-none' to={customerRoutes.homepage.getPath()}>
          <Trans>Close</Trans>
        </NoddiLink>
        <NewBookingButton className='flex-1 lg:flex-none' defaultSize />
      </div>
    </div>
  </ContentWrapperCustomerApp>
);
